import { Environment, Store, RecordSource, Network } from 'relay-runtime';
import { getBuyerToken } from 'dibs-cookie-jar';
const path = '/soa/graphql/';

function getUrl() {
    const { userToken } = getBuyerToken(document.cookie);
    const query = userToken ? `?userToken=${userToken}` : '';

    return `${path}${query}`;
}

function fetchQuery(operation, variables) {
    return fetch(getUrl(), {
        method: 'post',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            query: operation.text, // GraphQL text from input
            variables
        })
    }).then(response => {
        return response.json();
    });
}

let environment;

export default function getRelayEnvironment(records = {}) {
    if (!environment) {
        const network = Network.create(fetchQuery);
        const source = new RecordSource(records);
        const store = new Store(source);
        environment = new Environment({ network, store });
    }
    return environment;
}



// WEBPACK FOOTER //
// ./src/relayClientEnvironment.js